<div class="confirm-modal ig-modal pull-google-place-type-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div class="title">SELECT THE CATEGORIES TO PULL</div>

    <div class="edit-wrap">
        <div class="flex">
            <div *ngFor="let mainType of sources" class="type-column">
                <mat-checkbox class="main-type" [(ngModel)]="mainType.all" (ngModelChange)="selectAll(mainType)">{{mainType.text}}</mat-checkbox>
                <mat-checkbox *ngFor="let type of mainType.types" [(ngModel)]="type.checked" (ngModelChange)="onSelect(mainType)">{{type.text}}</mat-checkbox>
            </div>
<!--            <div class="type-column">-->
<!--                <mat-checkbox class="main-type" [(ngModel)]="typeSources.shopping.all" (ngModelChange)="selectAll(typeSources.shopping)">Shopping</mat-checkbox>-->
<!--                <mat-checkbox *ngFor="let type of typeSources.shopping.types" [(ngModel)]="type.checked" (ngModelChange)="onSelect(typeSources.shopping)">{{type.text}}</mat-checkbox>-->
<!--            </div>-->
<!--            <div class="type-column">-->
<!--                <mat-checkbox class="main-type" [(ngModel)]="typeSources.dining.all" (ngModelChange)="selectAll(typeSources.dining)">Dining</mat-checkbox>-->
<!--                <mat-checkbox *ngFor="let type of typeSources.dining.types" [(ngModel)]="type.checked" (ngModelChange)="onSelect(typeSources.dining)">{{type.text}}</mat-checkbox>-->
<!--            </div>-->
<!--            <div class="type-column">-->
<!--                <mat-checkbox class="main-type" [(ngModel)]="typeSources.accommodation.all" (ngModelChange)="selectAll(typeSources.accommodation)">Accommodation</mat-checkbox>-->
<!--                <mat-checkbox *ngFor="let type of typeSources.accommodation.types" [(ngModel)]="type.checked" (ngModelChange)="onSelect(typeSources.accommodation)">{{type.text}}</mat-checkbox>-->
<!--            </div>-->
<!--            <div class="type-column">-->
<!--                <mat-checkbox class="main-type" [(ngModel)]="typeSources.activity.all" (ngModelChange)="selectAll(typeSources.activity)">Activity</mat-checkbox>-->
<!--                <mat-checkbox *ngFor="let type of typeSources.activity.types" [(ngModel)]="type.checked" (ngModelChange)="onSelect(typeSources.activity)">{{type.text}}</mat-checkbox>-->
<!--            </div>-->
<!--            <div class="type-column">-->
<!--                <mat-checkbox class="main-type" [(ngModel)]="typeSources.art.all" (ngModelChange)="selectAll(typeSources.art)">Arts & Culture</mat-checkbox>-->
<!--                <mat-checkbox *ngFor="let type of typeSources.art.types" [(ngModel)]="type.checked" (ngModelChange)="onSelect(typeSources.art)">{{type.text}}</mat-checkbox>-->
<!--            </div>-->
<!--            <div class="type-column">-->
<!--                <mat-checkbox class="main-type" [(ngModel)]="typeSources.travel.all" (ngModelChange)="selectAll(typeSources.travel)">Travel</mat-checkbox>-->
<!--                <mat-checkbox *ngFor="let type of typeSources.travel.types" [(ngModel)]="type.checked" (ngModelChange)="onSelect(typeSources.travel)">{{type.text}}</mat-checkbox>-->
<!--            </div>-->
<!--            <div class="type-column">-->
<!--                <mat-checkbox class="main-type" [(ngModel)]="typeSources.entertainment.all" (ngModelChange)="selectAll(typeSources.entertainment)">Entertainment</mat-checkbox>-->
<!--                <mat-checkbox *ngFor="let type of typeSources.entertainment.types" [(ngModel)]="type.checked" (ngModelChange)="onSelect(typeSources.entertainment)">{{type.text}}</mat-checkbox>-->
<!--            </div>-->
<!--            <div class="type-column">-->
<!--                <mat-checkbox class="main-type" [(ngModel)]="typeSources.outdoor.all" (ngModelChange)="selectAll(typeSources.outdoor)">Outdoor & Fitness</mat-checkbox>-->
<!--                <mat-checkbox *ngFor="let type of typeSources.outdoor.types" [(ngModel)]="type.checked" (ngModelChange)="onSelect(typeSources.outdoor)">{{type.text}}</mat-checkbox>-->
<!--            </div>-->
<!--            <div class="type-column">-->
<!--                <mat-checkbox class="main-type" [(ngModel)]="typeSources.other.all" (ngModelChange)="selectAll(typeSources.other)">Other</mat-checkbox>-->
<!--                <mat-checkbox *ngFor="let type of typeSources.other.types" [(ngModel)]="type.checked" (ngModelChange)="onSelect(typeSources.other)">{{type.text}}</mat-checkbox>-->
<!--            </div>-->
        </div>

    </div>

    <hr>
    <div class="flex" style="justify-content:space-between">
        <div>
            <mat-checkbox [(ngModel)]="isSelectAll" (ngModelChange)="allIn()">Select All</mat-checkbox>
        </div>
        <div class="flex">
            <div class="cancel-btn pointer" style="text-decoration: underline;margin-top: 0" (click)="confirm()">
                OK
            </div>
            <div class="cancel-btn pointer" style="margin: 0 20px 0 51px" (click)="close()">
                Close
            </div>
        </div>
    </div>


</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/pull.google.place.type.modal/pull.google.place.type.modal.component.html